import "./mockCatalyst.js";

let currentUser = null;
const getProcess = window.catalyst.userManagement.getCurrentProjectUser()
    .then((result) => {
        console.log("Current user:", result);
        currentUser = result.content;
    })
    .catch((error) => {
        console.log("Error getting current user", error);
        currentUser = null;
    });

export async function getCurrentUser() {
    if (currentUser) return currentUser;
    await getProcess;
    return currentUser;
}

export async function isCurrentUserAuthenticated() {
    const curUser = await getCurrentUser();
    return curUser ? await window.catalyst.auth.isUserAuthenticated() : false;
}

export async function getCurrentUserRoleDetails() {
    const curUser = await getCurrentUser();
    return curUser ? (await getCurrentUser()).role_details : undefined;
}

export async function getCurrentUserId(){
    const curUser = await getCurrentUser();
    return curUser ? (await getCurrentUser()).user_id : undefined;
}

export async function isCurrentUserRoleIsAdmin() {
    const curUser = await getCurrentUser();
    return curUser ? (await getCurrentUserRoleDetails()).role_id === "30083000000008090" : false;
}

export async function isCurrentUserRoleIsTherapist() {
    const curUser = await getCurrentUser();
    return curUser ? (await getCurrentUserRoleDetails()).role_id === "30083000000039042" : false;
}

export async function isCurrentUserRoleIsUser() {
    const curUser = await getCurrentUser();
    return curUser ? (await getCurrentUserRoleDetails()).role_id === "30083000000008092" : false;
}
